<template>
    <full-page ref="fullpage" :options="options" id="fullpage">
        <slot />
    </full-page>
</template>
<script>
import "fullpage.js/vendors/scrolloverflow";

export default {
    data() {
        return {
            options: {
                licenseKey: "F12AC5DE-31464536-A1EB0847-00081308",
                menu: "#menu",
                anchors: ["page1", "page2", "page3", "page4"],
                navigation: true,
                scrollOverflow: true,
                normalScrollElements: ".overflow-y-auto, .overflow-y-scroll"
            }
        };
    }
};
</script>
